import { render } from "./MyCollection.vue?vue&type=template&id=b67cd80a&scoped=true&ts=true"
import script from "./MyCollection.vue?vue&type=script&lang=ts"
export * from "./MyCollection.vue?vue&type=script&lang=ts"

import "./MyCollection.vue?vue&type=style&index=0&id=b67cd80a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b67cd80a"]])

export default __exports__